<template>
  <div class="boti-intro">
    <img class="whatsapp-icon" :src="require('@/assets/onboarding/group@3x.jpg')"/>
    <div class="intro">
      <div class="text-wrapper">
        <div class="title">אנחנו איתך גם ב-<img class="whatsapp-icon" :src="require('@/assets/onboarding/icons/whatsapp.svg')"/></div>
        <div class="description">לאורך התהליך הבוט שלנו מלווה אותך בהודעות. בכל שלב ניתן לחזור לתהליך ההרשמה דרך הלינק המצורף בהודעות.</div>
      </div>
      <div class="button-wrapper">
        <div class="disclaimer">*לעולם לא נשלח לך הודעות שיווקיות או סתם ספאם</div>
        <riseup-button class="button" :size="'small'" :title="'הבנתי, מצוין'" :action="confirm"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../Segment';

export default {
  async created() {
    Segment.trackUserGot('WhatsappOptInEntered');
  },
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  name: 'BotiIntro',
  methods: {
    ...mapActions('signup', ['sendBotiIntro']),
    ...mapActions('onboardingState', ['nextPage']),
    confirm() {
      Segment.trackUserInteraction('WhatsappOptInConfirmClicked');
      this.sendBotiIntro();
      this.nextPage();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .boti-intro {
    @include white-page-frame;
    height: 100%;

    .whatsapp-icon {
      width: 100%;
    }
    .intro {
      @include responsive-padding;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .text-wrapper {
        .title {
          font-size: 22px;
          font-weight: bold;
          font-family: SimplerPro;
          position: relative;
          margin: 30px 0 20px;

          .whatsapp-icon {
            height: 28px;
            width: 122px;
            position: absolute;
            top: -5px;
            right: 162px;
          }
        }

        .description {
          font-family: SimplerPro;
          font-size: 18px;
          line-height: 1.33;
          margin-bottom: 30px;
        }
      }

      .button-wrapper {
        @include responsive-padding-top-bottom;

        .disclaimer {
          font-size: 14px;
          font-family: SimplerPro;
          text-align: center;
          margin-bottom: 20px;
        }

        .button {
          width: 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard2/steps/BotiIntro.vue